import { KpiTiles } from '../charts/KpiTiles.tsx';
import { TimeseriesChart } from '../charts/TimeseriesChart.tsx';
import { TopNChart } from '../charts/TopNChart.tsx';
import { Panel, ReportHeader } from '../components/Panel.tsx';

export function UmsatzReportPage() {
  return (
    <div className="space-y-6 w-full max-w-[1400px] mx-auto">
      <ReportHeader
        title="Umsatz-Übersicht"
        desc="Gesamtumsatz, Bons, Ø-Bon und Storno-Quote samt Zeitverlauf. Zeitraum, Filialen & Warengruppen passt du links im Filter an."
      />
      <KpiTiles />
      <Panel title="Umsatz im Zeitverlauf" subtitle="Tag / Woche / Monat / Jahr — mit Vorjahresvergleich">
        <TimeseriesChart />
      </Panel>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Panel title="Top-Filialen" subtitle="Nach Umsatz">
          <TopNChart dimension="store_name" measure="umsatz" limit={12} />
        </Panel>
        <Panel title="Top-Warengruppen" subtitle="Nach Umsatz">
          <TopNChart dimension="warengruppe_name" measure="umsatz" limit={12} />
        </Panel>
      </div>
    </div>
  );
}
